import RatesAndTermsPage from './RatesAndTermsPage.component';

export default RatesAndTermsPage;
